export enum MdNotificationItemType {
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
}

export interface MdNotification {
  title?: string;
  [MdNotificationItemType.ERROR]?: MdNotificationItem;
  [MdNotificationItemType.WARNING]?: MdNotificationItem;
  [MdNotificationItemType.INFO]?: MdNotificationItem;
}

export interface MdNotificationItem {
  readonly title: string;
  readonly items?: readonly string[];
}
